import { useState } from 'react';
import { Languages, ChevronDown } from 'lucide-react';

const LANGUAGES = [
  { code: 'fr', label: 'Français', flag: '🇫🇷' },
  { code: 'en', label: 'English',  flag: '🇺🇸' },
  { code: 'ar', label: 'العربية',  flag: '🇸🇦' },
];

const LoginLanguageSelector = ({ language, changeLanguage }) => {
  const [open, setOpen] = useState(false);
  const current = LANGUAGES.find(l => l.code === language) || LANGUAGES[0];

  return (
    <div className="flex justify-end mb-5 relative">
      <button
        type="button"
        onClick={() => setOpen(o => !o)}
        className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm transition-colors"
        style={{ backgroundColor: "var(--lm-s2)", border: "1px solid var(--lm-border)", color: "var(--lm-ink-2)" }}
        onMouseEnter={e => (e.currentTarget.style.borderColor = "var(--lm-border-2)")}
        onMouseLeave={e => (e.currentTarget.style.borderColor = "var(--lm-border)")}
      >
        <Languages className="w-3.5 h-3.5" />
        <span>{current.flag} {current.code.toUpperCase()}</span>
        <ChevronDown className="w-3 h-3" style={{ transform: open ? "rotate(180deg)" : "rotate(0)", transition: "transform 0.15s" }} />
      </button>

      {open && (
        <>
          <div className="fixed inset-0 z-10" onClick={() => setOpen(false)} />
          <div className="absolute top-10 right-0 w-36 rounded-xl overflow-hidden z-20"
            style={{ backgroundColor: "var(--lm-s2)", border: "1px solid var(--lm-border)" }}>
            {LANGUAGES.map(({ code, label, flag }) => (
              <button
                key={code}
                onClick={() => { changeLanguage(code); setOpen(false); }}
                className="w-full flex items-center gap-2 px-3 py-2 text-sm transition-colors text-left"
                style={{
                  backgroundColor: language === code ? "rgba(94,106,210,0.1)" : "transparent",
                  color: language === code ? "#828fff" : "var(--lm-ink-2)",
                }}
                onMouseEnter={e => { if (language !== code) e.currentTarget.style.backgroundColor = "var(--lm-s3)"; }}
                onMouseLeave={e => { if (language !== code) e.currentTarget.style.backgroundColor = "transparent"; }}
              >
                <span>{flag}</span>
                <span>{label}</span>
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default LoginLanguageSelector;
